import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await register(form); nav("/", { replace: true }); }
    catch (err) { toast.error(err?.response?.data?.detail || "Registration failed"); }
    finally { setBusy(false); }
  };
  return (
    <div className="blz-container py-14 max-w-md">
      <h1 className="font-display text-3xl font-bold">Create account</h1>
      <p className="text-sm text-slate-500 mt-1">Save orders, track deliveries and use your wishlist.</p>
      <form onSubmit={submit} className="card-flat p-6 mt-6 space-y-3">
        {[["name","Full name","text"],["email","Email","email"],["phone","Phone (optional)","tel"],["password","Password","password"]].map(([k,label,type]) => (
          <label key={k} className="block"><span className="text-xs font-semibold">{label}</span>
            <input type={type} value={form[k]} onChange={(e) => setForm({...form, [k]: e.target.value})} required={k !== "phone"} className="mt-1 w-full h-11 rounded-lg border border-slate-200 px-3" data-testid={`register-${k}`}/>
          </label>
        ))}
        <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="register-submit">{busy ? "Creating..." : "Create account"}</button>
      </form>
      <div className="text-sm mt-4 text-center">Already have an account? <Link to="/login" className="text-emerald-700 font-semibold">Sign in</Link></div>
    </div>
  );
}
